"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = {
    key: 0,
    class: "pr-2 text-white"
};
const _hoisted_2 = {
    key: 1,
    class: "pr-2 text-white"
};
const _hoisted_3 = {
    key: 2,
    class: "text-white"
};
const _hoisted_4 = {
    key: 0,
    class: "marso-icon-sort-asc"
};
const _hoisted_5 = {
    key: 1,
    class: "marso-icon-sort-desc"
};
const _hoisted_6 = {
    key: 3,
    class: "text-white"
};
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-sort" }, null, -1);
const _hoisted_8 = [
    _hoisted_7
];
const Filters_1 = __importDefault(require("../../stores/translation/Filters"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'TranslationFilterButton',
    props: {
        filters: {
            type: Filters_1.default,
        },
        column: {
            type: String,
        },
        label: {
            type: String,
        },
    },
    emits: ["click"],
    setup(__props, { emit }) {
        const click = () => {
            emit("click");
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                type: "button",
                class: "btn btn-link",
                onClick: _cache[0] || (_cache[0] = ($event) => (click()))
            }, [
                (__props.column !== undefined && ['key', 'context'].includes(__props.column))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_1, (0, vue_2.toDisplayString)(__props.label), 1))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_2, (0, vue_2.toDisplayString)(__props.label), 1)),
                (__props.filters !== undefined && 'key' === __props.filters.orderBy)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_3, [
                        ('asc' === __props.filters.orderDirection)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_4))
                            : (0, vue_2.createCommentVNode)("", true),
                        ('desc' === __props.filters.orderDirection)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("i", _hoisted_5))
                            : (0, vue_2.createCommentVNode)("", true)
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("span", _hoisted_6, _hoisted_8))
            ]));
        };
    }
});
